<template>
	<div class="goods-list">
		<HeaderBar></HeaderBar>
		<section>
			<div class="container">
				<b-dropdown text="公司动态" variant="outline-primary" class="mt-4 mb-4">
					<b-dropdown-item href="#">公司新闻</b-dropdown-item>
					<b-dropdown-item href="#">政策导向</b-dropdown-item>
				</b-dropdown>
			</div>
			<div class="row">
				<div class="col-lg-4">
					<div class="goods-box">
						<div class="goods-img">
							<img src="../assets/car.png" width="100%" />
						</div>
					</div>
				</div>
			</div>
		</section>
		<FooterBar></FooterBar>
	</div>
</template>

<script>
import HeaderBar from '@/components/header-bar';
import FooterBar from '@/components/footer-bar';
export default {
	name: 'Home',
	components: {
		HeaderBar,
		FooterBar,
	},
	data() {
		return {};
	},
	computed: {},
	mounted() {},
	methods: {
		goDetail() {
			this.$router.push({ path: 'goods-detail' });
		},
	},
};
</script>
<style lang="scss">
.goods-list {
}
</style>
